import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { EditTypePracticeCrubs } from 'practice/constants/type-practice-crubs';
import FormTypePractice, { FormTypePracticeVM } from 'practice/components/type-practice/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypePracticeData } from 'shell/models/type-practice';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { typePracticeResponseTransformer } from 'practice/utils/typepractice-response-transformer';

const EditTypePractice = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [typePractice] = useHttpFetch<HttpResponse<TypePracticeData>, FormTypePracticeVM>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-pratica/${params?.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {
          key: {
            tipoPratica: params?.id,
          },
        },
      },
      transformer: typePracticeResponseTransformer,
    }
  );

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-tipo-pratica');
  });

  const updatePractice = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/tipo-pratica/`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormTypePracticeVM) => {
      (
        updatePractice({
          data: {
            tipoRegistro: values.typeRegister || '',
            descrizioneBreveTipoPratica: values.descriptionBrief || '',
            descrizioneTipoPratica: values.description || '',
            tipoIniziativa: values.typeInitiative || '',
            key: {
              tipoPratica: values.code,
            },
            unitaMisuraTempo: values.measure || '',
            tempoStandard: values.timeStandard
              ? Number.parseInt(values.timeStandard?.toString())
              : undefined,
            tempoMax: values.timeMax ? Number.parseInt(values.timeMax?.toString()) : undefined,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-tipo-pratica');
      });
    },
    [navigate, updatePractice]
  );

  return (
    <Fragment>
      <Breadcrumbs items={EditTypePracticeCrubs} />
      {typePractice.isLoading || typePractice.pristine || typePractice.hasErrors ? undefined : (
        <FormTypePractice
          title="Modifica Tipo Pratica"
          onCancel={onCancel}
          isEdit
          onSubmit={onSubmit}
          initialValues={typePractice?.data as FormTypePracticeVM}
        />
      )}
    </Fragment>
  );
};

EditTypePractice.displayName = 'Edit Type Practice Page component';

export default EditTypePractice;
